import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import "react-step-progress-bar/styles.css";
import { ProgressBar } from "react-step-progress-bar";
import { SignupWithoutOtp, ResendOtp, AskOtp, VerifyOtp } from "../../redux/actions/AuthAction";


import { useHistory } from "react-router";
import demologo from "../../assets/demologo.png";
import { useSnackbar } from "react-simple-snackbar";
import razorpayPaymentHelper from "../../helpers/RazorpayPaymentHelper";
import Swal from "sweetalert2";
import { currencyConverter } from "../../helpers/planPrice";
import { getDevice } from "../../helpers/PageHelper";
import { SubscribeUser } from "../../redux/actions/UserAction";
import {
  ApplyCuponCode,
  CaptureStripePayment,
  FetchAllPlan,
  getPlan,
  getPlanIELTS,
} from "../../redux/actions/PlanAction";
const Payment = ({ subject }) => {
  const history = useHistory()
  const dispatch = useDispatch();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [content, setContent] = useState(null);
  const [contentIELTS, setContentIELTS] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  // const [grandTotal, setGrandTotal] = useState(null);
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  const user = JSON.parse(localStorage.getItem("USER"));
  const token = JSON.parse(localStorage.getItem("TOKEN"))

  const { search } = useLocation();
  const planType = new URLSearchParams(search).get("type");
  console.log(planType)
  //redux store
  const Plans = useSelector((state) => state.PlanReducer.plans);
  const KidsPlans = useSelector((state) => state.PlanReducer.kidsPlan);
  const IELTSPlans = useSelector((state) => state.PlanReducer.IELTSPlan);

  console.log(user._id)
  console.log(Plans ? Plans : "")
  console.log(KidsPlans ? KidsPlans : "")
  console.log(IELTSPlans ? IELTSPlans : "")

  useEffect(() => {

    const onSuccess = (data) => {
      console.log(data);
      setContent(data);
    };
    const onSuccessIELTS = (data) => {
      console.log(data);
      setContentIELTS(data);
    };
    dispatch(getPlan(onSuccess));
    dispatch(getPlanIELTS(onSuccessIELTS));
    dispatch(FetchAllPlan());


  }, []);

  useEffect(() => {
    if (planType === "kids") {
      console.log("KIDS")
      if (KidsPlans) {
        KidsPlans.map((data, i) => {
          if (
            data.classDuration === "25min" &&
            data.month === 6
          ) {

            setPlanDetails(data);
          }
        });
      }
    } else if (planType === "IELTS") {
      console.log("IELTS")
      if (IELTSPlans) {
        IELTSPlans.map((data, i) => {
          if (
            data.classDuration === "55min" &&
            data.frequency === 3
          ) {

            setPlanDetails(data);
          }
        })
      };
    } else {
      if (Plans) {
        Plans.map((data, i) => {
          if (
            data.classDuration === "15min" &&
            data.frequency === 5
          ) {

            setPlanDetails(data);
          }
        });
      }
    }
  }, [Plans]);
    //
  //Calcultions
  //IIFE
  const discountPrice = (() => {
    if (planType === "kids") {
      return (
        Math.round(
          ((planDetails?.originalPrice) / 100) * planDetails?.discount)
      )
    } else if (planType === "IELTS") {
      console.log("IELTS DISCOUNT")
      return (
        Math.round(
          ((planDetails?.originalPrice * 3) / 100) * contentIELTS?.months[1].discount)
      )
    } else {
      return (
        Math.round(
          ((planDetails?.originalPrice * 6) / 100) * content?.months[2].discount
        )
      )
    }
  })()

  const total = (() => {
    if (planType === "kids") {
      return (
        Math.round(
          planDetails?.originalPrice - discountPrice
        )
      )
    } else if (planType === "IELTS") {
      return (
        Math.round(
          planDetails?.originalPrice * 3 - discountPrice
        )
      )
    }
    else {
      return (
        Math.round(
          planDetails?.originalPrice * 6 - discountPrice
        )
      )
    }
  })()
  // var total = Math.round(
  //   planDetails?.originalPrice * 6 - discountPrice
  // );
  var gstamount = Math.round((total / 100) * 18);
  var grandTotal = total + gstamount;
  console.log("DISCOUNT", discountPrice)
  console.log("TOTAL", total)
  console.log("GST", gstamount)
  console.log("GRANDTOTAL", grandTotal)
  console.log(content ? content : "")
  console.log(contentIELTS ? contentIELTS : "")
  console.log(planDetails ? planDetails : "")
  // console.log(total)
  //Subscribe

  const SubscribeClapingo = () => {
    setPaymentLoader(true);
    const userCurrency = time_zone.country === "IN" ? "INR" : "USD";
    const userData = time_zone.timezone;
    const val = userData.split("/");
    const calculatedAmount = time_zone.country === "IN" ? grandTotal : grandTotal / 100;
    const data = {
      amount: calculatedAmount,
      payment_capture: 1,
      currency: userCurrency,
      notes: {
        Name: user.name,
        Number: user.phoneNumber,
        Email: user.email,
        learnerID: user._id,
        planId: planDetails._id,
        month: 6,
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        paymentDetails: planDetails.courseName + "(from web)",
        currency: userCurrency,
        subscriptionName: planDetails.courseName,
        amount: calculatedAmount,
      },
      txndesc: planDetails.courseName,
    };

    const onSuccess = (rzpRes) => {
      setPaymentLoader(true)
      var data = {
        learnerId: user._id,
        planId: planDetails._id,
        month: planType==="IELTS" ? 3 :6,
        zone1: val[0],
        zone2: val.length > 1 ? val[1] : undefined,
        paymentDetails: planDetails.courseName + "(from homepage)",
        order_id: rzpRes.razorpay_order_id,
        currency: userCurrency,
        subscriptionName: planDetails.courseName,
        transactionId: rzpRes.razorpay_order_id,
        amount: calculatedAmount,
        subject:planType==="IELTS" ? "IELTS": "English",
        source: getDevice(),
      };

      const subscriptionSuccess = () => {
        localStorage.setItem("SUBSCRIBED", JSON.stringify(true));
        // handleShow();
        localStorage.setItem("planSubscribed", JSON.stringify({month:data.month, amount:data.amount, subsName:data.subscriptionName}))
        localStorage.removeItem("ADD_PAGE");
        setPaymentLoader(false);
        Swal.fire("Subscribed Successfully!", "", "success")
        history.push(`/home-subscription/success?type=${planType}`)


      };

      const subscriptionFailed = (errmsg) => {
        setPaymentLoader(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: errmsg,
        });
      };
      console.log(data);
      dispatch(SubscribeUser(data, subscriptionSuccess, subscriptionFailed, token));
    };

    const modalClose = () => {
      setPaymentLoader(false);
    };
    razorpayPaymentHelper(data, onSuccess, modalClose);
  };

  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">
          <div className="steps">
            <div className="steps-flex">
              <p className="step1" style={{ fontWeight: "bolder", color: "#24A15C" }}>STEP-1</p>
              <p className="step2" style={{ fontWeight: "bolder", color: "#24A15C" }}>STEP-2</p>
              <p className="step3" style={{ fontWeight: "bolder" }}>STEP-3</p>
            </div>
            <ProgressBar
              percent={50}
              filledBackground="linear-gradient(to right, #24A15C, #44E18C)"
            />
          </div>
          {paymentLoader ?
            <div className="mt-5">
              <h6 className="text-center">Processing payment, please wait</h6>
              <div className="text-center">
                <div className="spinner-grow" role="status">
                  <span className="sr-only"></span>
                </div>
              </div>
            </div> :
            <div>
              <div className="billing mt-3">
                <h6>PLAN SUMMARY</h6>
                <div className="summery mt-4">
                  <div className="d-flex justify-content-between">
                    <p>Total Months :</p>
                    <p>
                      {planType === "IELTS" ? "3 Months" : "6 Months"}


                    </p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="discount">Session Duration:</p>
                    <p className="discount">

                      {planDetails?.classDuration}
                    </p>
                  </div>

                  <div className="d-flex justify-content-between">
                    <p className="discount">{planType === "kids" ? "No. of Sessions" : "Session Frequency:"}</p>
                    <p className="discount">

                      <p className="discount">
                        {planType === "kids" ? `${planDetails?.totalSession} Sessions` : ` ${planDetails?.frequency}days/week`}

                      </p>
                    </p>
                  </div>



                  <hr />

                </div>
                <h6>BILL SUMMARY</h6>
                <div className="summery mt-4">
                  <div className="d-flex justify-content-between">
                    <p>Sub-Total :</p>
                    <p >

                      {planType === "kids" ?
                        "₹" +
                        new Intl.NumberFormat().format(
                          Math.round(planDetails?.originalPrice)
                        ) : planType === "IELTS" ?
                          "₹" +
                          new Intl.NumberFormat().format(
                            Math.round(planDetails?.originalPrice * 3)
                          )
                          : "₹" +
                          new Intl.NumberFormat().format(
                            Math.round(planDetails?.originalPrice * 6)
                          )


                      }

                    </p>
                  </div>
                  <div className="d-flex justify-content-between">
                    <p className="discount">Discount({planType === "IELTS" ? "25%" : planType==="adults"?"35%": "30%"}):</p>
                    <p className="discount" style={{ color: "red" }}>
                      {" "}
                      {"-₹" + new Intl.NumberFormat().format(discountPrice)
                      }
                    </p>
                  </div>

                  {time_zone.country === "IN" ?
                    <div className="d-flex justify-content-between">
                      <p>GST Charges(18%) :</p>
                      <p> ₹ {new Intl.NumberFormat().format(gstamount)}</p>
                    </div>
                    : ""
                  }


                  <hr />
                  <div className="d-flex justify-content-between grand-total">
                    <p className="grand-total">Grand Total :</p>
                    <p style={{ color: "green" }}>
                      {time_zone.country === "IN"
                        ? "₹" + new Intl.NumberFormat().format(grandTotal)
                        : currencyConverter(grandTotal / 100)}
                    </p>
                  </div>
                </div>


              </div>
              <div className="d-flex justify-content-center">
                <button
                  onClick={(e) => SubscribeClapingo(e)}
                  className={"continueBTN btn-block  mx-auto "}
                >{paymentLoader ? (
                  "Loading ..."
                ) : (
                  "Make Payment"
                )}</button>
              </div>
            </div>}
        </div>
      </div>
    </div>

  )
}

export default Payment;
